console.log('[upgradeAddOns] product-form.js loaded', {
  alreadyDefined: Boolean(customElements.get('product-form')),
});

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log('[upgradeAddOns] 1. submit started', {
          ariaDisabled: this.submitButton.getAttribute('aria-disabled'),
        });
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          console.log('[upgradeAddOns] stopped: button is aria-disabled');
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const addonItems = [];
        const seenAddonIds = new Set();
        const pushAddon = (id) => {
          if (!id || seenAddonIds.has(String(id))) return;
          seenAddonIds.add(String(id));
          addonItems.push({ id, quantity: 1 });
        };
        const formAddonIds = formData.getAll('upgrade_addon_variant_id');
        console.log('[upgradeAddOns] 2. ids inside the product form', formAddonIds);
        formAddonIds.forEach(pushAddon);

        const checkedAddons = Array.from(document.querySelectorAll('input[name="upgrade_addon_variant_id"]')).map(
          (input) => ({
            value: input.value,
            checked: input.checked,
            form: input.getAttribute('form'),
          })
        );
        console.log('[upgradeAddOns] 3. checkboxes on the page', checkedAddons);
        document.querySelectorAll('input[name="upgrade_addon_variant_id"]:checked').forEach((input) => {
          pushAddon(input.value);
        });

        console.log('[upgradeAddOns] 4. collector exists', Boolean(window.collectUpgradeAddOnItems));
        if (window.collectUpgradeAddOnItems) window.collectUpgradeAddOnItems(addonItems);
        console.log('[upgradeAddOns] 5. add-ons that will be sent', addonItems);
        const normalizeVariantId = (id) => {
          const numericId = Number(id);
          return Number.isSafeInteger(numericId) && String(numericId) === String(id) ? numericId : id;
        };

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (this.cart) this.cart.setActiveElement(document.activeElement);

        let cartAddUrl = routes.cart_add_url;
        if (addonItems.length) {
          const items = [];
          const mainId = formData.get('id');
          if (mainId) {
            const mainItem = {
              id: normalizeVariantId(mainId),
              quantity: parseInt(formData.get('quantity') || '1', 10) || 1,
            };
            const properties = {};
            for (const [key, value] of formData.entries()) {
              const match = key.match(/^properties\[(.*)\]$/);
              if (match) properties[match[1]] = value;
            }
            if (Object.keys(properties).length) mainItem.properties = properties;
            const sellingPlan = formData.get('selling_plan');
            if (sellingPlan) mainItem.selling_plan = normalizeVariantId(sellingPlan);
            items.push(mainItem);
          }

          addonItems.forEach((item) => {
            items.push({
              id: normalizeVariantId(item.id),
              quantity: item.quantity || 1,
            });
          });

          const payload = { items };
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
          }

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);
          cartAddUrl = String(routes.cart_add_url || '/cart/add').replace(/\.js$/, '') + '.js';
          console.log('[upgradeAddOns] 6. sending product + add-ons', {
            url: cartAddUrl,
            items: payload.items,
          });
        } else {
          console.log('[upgradeAddOns] 6. no add-on selected, sending the main product only');
          delete config.headers['Content-Type'];
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
        }

        fetch(cartAddUrl, config)
          .then((response) => {
            console.log('[upgradeAddOns] 7. cart response status', response.status);
            return response.json();
          })
          .then((response) => {
            console.log('[upgradeAddOns] 8. cart response body', response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              console.log('[upgradeAddOns] 9. add finished, opening the cart page');
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('[upgradeAddOns] request failed', e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
